import createLucideIcon from '../createLucideIcon';

const Navigation = createLucideIcon('NavigationIcon', [
  ['polygon', { points: '3 11 22 2 13 21 11 13 3 11', key: '1ltx0t' }],
]);

export default Navigation;
